import WelcomeContainer from "../../container/participant/welcome/welcomeContainer";

const WelcomeParticipant = (): React.JSX.Element => <WelcomeContainer />;

export default WelcomeParticipant;
